'use client';
import { ComponentType } from 'react';
import { PlaceholderConfig } from '@spa/lib/react/context/PlaceholderContext';
import { Props } from './process-steps.component';
import dynamic from 'next/dynamic';

const DynamicProcessStepsComponent: ComponentType<Props> = dynamic(
  () => import('./process-steps.component')
);

export default DynamicProcessStepsComponent;

export function calculateProcessStepsPlaceholderConfig(): PlaceholderConfig {
  const heightSinceWidth = [{ sinceWidth: 0, height: 100 }];

  return {
    heightSinceWidth
  };
}
